import { render, staticRenderFns } from "./PcDialog.vue?vue&type=template&id=5fdbb452&scoped=true&"
import script from "./PcDialog.vue?vue&type=script&lang=js&"
export * from "./PcDialog.vue?vue&type=script&lang=js&"
import style0 from "./PcDialog.vue?vue&type=style&index=0&id=5fdbb452&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdbb452",
  null
  
)

export default component.exports